import React, { useState, useEffect } from 'react';
import { Button, Popup } from 'semantic-ui-react';

const STORAGE_KEY = 'gettelFabClusterExpanded';

/** Espaço extra no fundo do conteúdo rolável para os FABs fixos não cobrirem paginação / rodapés. */
export const FAB_CLUSTER_SCROLL_RESERVE_PX = 200;

interface FloatingFabClusterProps {
  children: React.ReactNode;
}

/**
 * Agrupa FABs no canto inferior direito em coluna, com opção de recolher (persistida em localStorage).
 */
const FloatingFabCluster: React.FC<FloatingFabClusterProps> = ({ children }) => {
  const [expanded, setExpanded] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw === null) return true;
      return JSON.parse(raw) === true;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(expanded));
    } catch {
      /* ignore */
    }
  }, [expanded]);

  const anchorStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
  };

  if (!expanded) {
    return (
      <div style={anchorStyle}>
        <Popup
          content="Mostrar atalhos"
          position="left center"
          trigger={
            <Button
              type="button"
              circular
              icon="chevron up"
              aria-label="Mostrar atalhos flutuantes"
              onClick={() => setExpanded(true)}
              style={{
                width: '44px',
                height: '44px',
                minWidth: '44px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                background: 'rgba(255, 255, 255, 0.95)',
              }}
            />
          }
        />
      </div>
    );
  }

  return (
    <div
      style={{
        ...anchorStyle,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '12px',
      }}
    >
      <Popup
        content="Recolher atalhos"
        position="left center"
        trigger={
          <Button
            type="button"
            circular
            icon="chevron down"
            size="small"
            aria-label="Recolher atalhos flutuantes"
            aria-expanded={expanded}
            onClick={() => setExpanded(false)}
            style={{
              width: '36px',
              height: '36px',
              minWidth: '36px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
              background: 'rgba(255, 255, 255, 0.95)',
            }}
          />
        }
      />
      {children}
    </div>
  );
};

export default FloatingFabCluster;
